module.exports = __webpack_public_path__ + "img/caja_seguridad.398baec2.svg";